import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Loader } from '../../common'
import LaundryBookingsTable from '../../containers/LaundryBookingsTable'

import * as dataActions from '../../actions/Data'

class LaundryBookings extends React.Component {
  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.laundrySystem) {
      this.props.tryGetLaundrySystem(user.token, data.community.id)
    }
  }

  render() {
    const { classes, data } = this.props

    if (!data.laundrySystem) {
      return (
        <main className={classes.content}>
          <Loader />
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <LaundryBookingsTable />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

LaundryBookings.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...dataActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LaundryBookings)



// WEBPACK FOOTER //
// ./src/components/pages/LaundryBookings/index.js